import type React from 'react'
import {useDetails, Details} from '@primer/react'
import {ChevronDownIcon, ChevronUpIcon} from '@primer/octicons-react'

import type {NoResultDataItem} from './data'
import styles from './Tips.module.css'

import {clsx} from 'clsx'

export default function Tips({data}: {data: NoResultDataItem[]}) {
  return (
    <div className={styles.tipsOuterWrapper}>
      <div className={styles.tipsInnerWrapper}>
        {data.map((t, index) => {
          return (
            <TipItem name={t.name} key={t.name} defaultOpen={index === 0} isLastItem={index + 1 === data.length}>
              {t.content}
            </TipItem>
          )
        })}
      </div>
    </div>
  )
}

interface TipItemProps {
  children?: React.ReactNode
  name: string
  defaultOpen: boolean
  isLastItem: boolean
}

function TipItem({children, name, isLastItem, defaultOpen = false}: TipItemProps) {
  const {getDetailsProps, open} = useDetails({closeOnOutsideClick: false})
  const {onToggle, ref, ...detailsProps} = getDetailsProps()

  return (
    <Details
      {...detailsProps}
      ref={ref}
      open={defaultOpen}
      onToggle={onToggle}
      className={clsx(styles.Details, isLastItem && open && styles.OpenLastItem)}
    >
      <summary className={clsx(styles.tipSummary, open && styles.tipSummaryOpen)}>
        <span className={styles.tipName}>{name}</span>
        {open ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
      </summary>
      {open && <div className={clsx(styles.tipContent, isLastItem && styles.tipContentLastItem)}>{children}</div>}
    </Details>
  )
}
